export enum BankAccountStatus {
  UNVERIFIED = 1,
  PENDING,
  VERIFIED,
  REJECTED,
  FREEZE,
}
